// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"8584d641","338":"b5227c4d","548":"c3bda952"}[chunkId] + ".chunk.js";
};